// extracted by mini-css-extract-plugin
export var backgroundImage = "Section-module--backgroundImage--aafef";
export var hasBackground = "Section-module--hasBackground--06f2a";
export var inverted = "Section-module--inverted--9d1ac";
export var noPadding = "Section-module--noPadding--9860d";
export var paddingExtraLight = "Section-module--paddingExtraLight--7c727";
export var paddingHeavy = "Section-module--paddingHeavy--bc92b";
export var paddingLight = "Section-module--paddingLight--7112e";
export var section = "Section-module--section--33a8b";